import ENV from '@/constants/env';
import { InvalidTypeError, InvalidOptionValueError } from '@/utils/errors';
import { IS_DEVELOPMENT } from '@/constants/server';
import { isString } from '@/utils/inspect';

const FEATURE_FLAGS = Object.freeze({
  /**
   * Активирует mock адаптер
   * Запросы, для которых не описаны обработчики, уходят  на бэкенд
   */
  MOCKED_API: ENV.FEATURE_MOCKED_API === 'true' && IS_DEVELOPMENT,
  /**
   * Активирует mock адаптер, смотрящий в локальный mock сервер
   */
  MOCKED_API_LOCAL_SERVER: ENV.FEATURE_MOCKED_API_LOCAL_SERVER === 'true' && IS_DEVELOPMENT,
});
const FEATURE_FLAG_KEYS = Object.keys(FEATURE_FLAGS);

/**
 * @param {String} flag
 * @returns {Boolean}
 */
function exist(flag) {
  return FEATURE_FLAG_KEYS.includes(flag);
}

export const featureProvider = {
  /**
   * @param {String} flag
   * @returns {Boolean}
   */
  enabled(flag) {
    if (!isString(flag)) {
      throw new InvalidTypeError(flag, 'flag', 'String');
    }
    if (!exist(flag)) {
      throw new InvalidOptionValueError('flag', FEATURE_FLAG_KEYS);
    }

    return FEATURE_FLAGS[flag];
  },
};
